{
	"navigation": {
		"moreLabel": "Mer"
	},
	"useDeclarationCreationFormStore": {
		"errorMessages": {
			"fetchDefaultMaterial": "Kunne ikke hente materiale",
			"submitDeclaration": "Kunne ikke sende inn erklæring"
		}
	},
	"country": {
		"AC": "Ascension Island",
		"AD": "Andorra",
		"AE": "De forente arabiske emirater",
		"AF": "Afghanistan",
		"AG": "Antigua og Barbuda",
		"AI": "Anguilla",
		"AL": "Albania",
		"AM": "Armenia",
		"AO": "Angola",
		"AQ": "Antarktis",
		"AR": "Argentina",
		"AS": "Amerikansk Samoa",
		"AT": "Østerrike",
		"AU": "Australia",
		"AW": "Aruba",
		"AX": "Åland",
		"AZ": "Aserbajdsjan",
		"BA": "Bosnia-Hercegovina",
		"BB": "Barbados",
		"BD": "Bangladesh",
		"BE": "Belgia",
		"BF": "Burkina faso",
		"BG": "Bulgaria",
		"BH": "Bahrain",
		"BI": "Burundi",
		"BJ": "Benin",
		"BL": "Saint Barthélemy",
		"BM": "Bermuda",
		"BN": "Brunei",
		"BO": "Bolivia",
		"BQ": "Karibiske Nederland",
		"BR": "Brasil",
		"BS": "Bahamas",
		"BT": "Bhutan",
		"BV": "Bouvetøya",
		"BW": "Botswana",
		"BY": "Hviterussland",
		"BZ": "Belize",
		"CA": "Canada",
		"CC": "Cocos Island",
		"CD": "Kongo DR",
		"CEFTA": "Cefta",
		"CF": "Den sentralafrikanske republikk",
		"CG": "Republikken Kongo",
		"CH": "Sveits",
		"CI": "Elfenbenskysten",
		"CK": "Cookøyene",
		"CL": "Chile",
		"CM": "Kamerun",
		"CN": "Kina",
		"CO": "Colombia",
		"CP": "Clipperton Island",
		"CR": "Costa Rica",
		"CU": "Cuba",
		"CV": "Cabo Verde",
		"CW": "Curaçao",
		"CX": "Juleøya",
		"CY": "Kypros",
		"CZ": "Tsjekkia",
		"DE": "Tyskland",
		"DG": "Diego Garcia",
		"DJ": "Djibouti",
		"DK": "Danmark",
		"DM": "Dominica",
		"DO": "Den dominikanske republikk",
		"DZ": "Algerie",
		"ES": "Spania",
		"EC": "Ecuador",
		"EE": "Estland",
		"EG": "Egypt",
		"EH": "Vest-Sahara",
		"ER": "Eritrea",
		"CT": "Catalunya (Spania)",
		"PV": "Baskerland (Spania)",
		"ES-TR": "Spanias territorium",
		"ET": "Etiopia",
		"EU": "Den europeiske union",
		"FI": "Finland",
		"FJ": "Fiji",
		"FK": "Falklandsøyene",
		"FM": "Mikronesia",
		"FO": "Færøyene",
		"FR": "Frankrike",
		"GA": "Gabon",
		"ENG": "England",
		"NIR": "Nord-Irland",
		"SCT": "Skottland",
		"WLS": "Wales",
		"GB": "Storbritannia",
		"GD": "Grenada",
		"GE": "Georgia",
		"GF": "Fransk Guyana",
		"GG": "Guernsey",
		"GH": "Ghana",
		"GI": "Gibraltar",
		"GL": "Grønland",
		"GM": "Gambia",
		"GN": "Guinea",
		"GP": "Guadeloupe",
		"GQ": "Ekvatorial-Guinea",
		"GR": "Hellas",
		"GS": "Sør-Georgia og Sør-Sandwichøyene",
		"GT": "Guatemala",
		"GU": "Guam",
		"GW": "Guinea-Bissau",
		"GY": "Guyana",
		"HK": "Hong Kong",
		"HM": "Heard Island og McDonald Islands",
		"HN": "Honduras",
		"HR": "Kroatia",
		"HT": "Haiti",
		"HU": "Ungarn",
		"IC": "Kanariøyene",
		"ID": "Indonesia",
		"IE": "Irland",
		"IL": "Israel",
		"IM": "Isle of Mann",
		"IN": "India",
		"IO": "Britisk territorium i det indiske hav",
		"IQ": "Irak",
		"IR": "Iran",
		"IS": "Island",
		"IT": "Italia",
		"JE": "Jersey",
		"JM": "Jamaica",
		"JO": "Jordan",
		"JP": "Japan",
		"KE": "Kenya",
		"KG": "Kirgisistan",
		"KH": "Kambodsja",
		"KI": "Kiribati",
		"KM": "Komorene",
		"KN": "Saint Kitts og Nevis",
		"KP": "Nord-Korea",
		"KR": "Sør-Korea",
		"KW": "Kuwait",
		"KY": "Caymanøyene",
		"KZ": "Kasakhstan",
		"LA": "Laos",
		"LB": "Libanon",
		"LC": "Saint Lucia",
		"LI": "Liechtenstein",
		"LK": "Sri Lanka",
		"LR": "Liberia",
		"LS": "Lesotho",
		"LT": "Litauen",
		"LU": "Luxembourg",
		"LV": "Latvia",
		"LY": "Libya",
		"MA": "Marokko",
		"MC": "Monaco",
		"MD": "Moldova",
		"ME": "Montenegro",
		"MF": "Saint Martin",
		"MG": "Madagaskar",
		"MH": "Marshalløyene",
		"MK": "Nord-Makedonia",
		"ML": "Mali",
		"MM": "Myanmar (Burma)",
		"MN": "Mongolia",
		"MO": "Macau",
		"MP": "Nord-Marianene",
		"MQ": "Martinique",
		"MR": "Mauritania",
		"MS": "Montserrat",
		"MT": "Malta",
		"MU": "Mauritius",
		"MV": "Maldivene",
		"MW": "Malawi",
		"MX": "Mexico",
		"MY": "Malaysia",
		"MZ": "Mosambik",
		"NA": "Namibia",
		"NC": "Ny-Caledonia",
		"NE": "Niger",
		"NF": "Norfolkøya",
		"NG": "Nigeria",
		"NI": "Nicaragua",
		"NL": "Nederland",
		"NO": "Norge",
		"NP": "Nepal",
		"NR": "Nauru",
		"NU": "Niue",
		"NZ": "New Zealand",
		"OM": "Oman",
		"PA": "Panama",
		"PE": "Peru",
		"PF": "Fransk Polynesia",
		"PG": "Papua Ny-Guinea",
		"PH": "Filippinene",
		"PK": "Pakistan",
		"PL": "Polen",
		"PM": "Saint Pierre og Miquelon",
		"PN": "Pitcairnøyene",
		"PR": "Puerto Rico",
		"PS": "Palestina",
		"PT": "Portugal",
		"PW": "Palau",
		"PY": "Paraguay",
		"QA": "Qatar",
		"RE": "Gjenforening",
		"RO": "Romania",
		"RS": "Serbia",
		"RU": "Russland",
		"RW": "Rwanda",
		"SA": "Saudi-Arabia",
		"SB": "Salomonøyene",
		"SC": "Seychellene",
		"SD": "Sudan",
		"SE": "Sverige",
		"SG": "Singapore",
		"SH": "Saint Helena Ascension og Tristan da Cunha",
		"SI": "Slovenia",
		"SJ": "Svalbard og Jan Mayen",
		"SK": "Slovakia",
		"SL": "Sierra Leone",
		"SM": "San Marino",
		"SN": "Senegal",
		"SO": "Somalia",
		"SR": "Surinam",
		"SS": "Sør-Sudan",
		"ST": "São Tomé og Príncipe",
		"SV": "El Salvador",
		"SX": "Sint Maarten",
		"SY": "Syria",
		"SZ": "Swaziland",
		"SZ-2": "Eswatini",
		"TA": "Tristan da Cunha",
		"TC": "Turks og Caicos Island",
		"TD": "Tsjad",
		"TF": "franske sørlige og antarktiske land",
		"TG": "Togo",
		"TH": "Thailand",
		"TJ": "Tadsjikistan",
		"TK": "Tokelau",
		"TL": "Øst-Timor",
		"TM": "Turkmenistan",
		"TN": "Tunisia",
		"TO": "Tonga",
		"TR": "Kalkun",
		"TT": "Trinidad og Tobago",
		"TV": "Tuvalu",
		"TW": "Taiwan",
		"TZ": "Tanzania",
		"UA": "Ukraina",
		"UG": "Uganda",
		"US": "USA",
		"UN": "FN",
		"US-2": "OSS",
		"UY": "Uruguay",
		"UZ": "Usbekistan",
		"VA": "Vatikanstaten",
		"VC": "Saint Vincent og Grenadinene",
		"VE": "Venezuela",
		"VG": "De britiske jomfruøyene",
		"VI": "De amerikanske jomfruøyene",
		"VN": "Vietnam",
		"VU": "Vanuatu",
		"WF": "Wallis og Futuna",
		"WS": "Samoa",
		"XK": "Kosovo",
		"YE": "Jemen",
		"YT": "Mayotte",
		"ZA": "Sør-Afrika",
		"ZM": "Zambia",
		"ZW": "Zimbabwe"
	},
	"languages": {
		"bg-BG": "Bulgarsk",
		"cs-CZ": "Tsjekkisk",
		"de-DE": "Tysk",
		"en-US": "Engelsk",
		"el-GR": "Gresk",
		"es-ES": "Spansk",
		"fr-FR": "Fransk",
		"it-IT": "Italiensk",
		"nl-NL": "Nederlandsk",
		"no-NO": "Norsk",
		"pl-PL": "Polsk",
		"ro-RO": "Rumensk",
		"sv-SE": "Svensk"
	},
	"traceIdBadge": {
		"traceIdLabel": "Sporings-ID"
	},
	"units": {
		"kg": "kg",
		"ton": "t",
		"m3": "M3",
		"co2": "CO\u2082 ekv.",
		"kgCO2": "kg CO\u2082 ekv."
	}
}
